<template>
  <div class="data-panel">
    <h3 class="data-title">Módulos</h3>
    <p style="font-size:13px;color:#6b7280;margin:0 0 20px;">Habilite ou desabilite modos e funcionalidades para esta obra. Módulos desabilitados ficam ocultos para todos os usuários.</p>
    <div v-if="flagsLoading" style="color:#6b7280;font-size:14px;">Carregando...</div>
    <div v-else>
      <!-- Modes group -->
      <div class="module-group">
        <div class="module-group-title">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
          Modos de operação
          <button class="flags-save-inline" type="button" :disabled="flagsSaving" @click="saveFlags">
            {{ flagsSaving ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
        <div class="module-cards">
          <template v-for="flag in featureFlags" :key="flag.key">
            <label v-if="['construction','maintenance','warehouse','office','portaria','ia'].includes(flag.key)" class="module-card" :class="{ 'module-card--on': flag.enabled, [`module-card--${flag.key}`]: true }">
              <div class="module-card-top">
                <!-- Construction icon -->
                <svg v-if="flag.key === 'construction'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                <!-- Maintenance icon -->
                <svg v-else-if="flag.key === 'maintenance'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
                <!-- Warehouse icon -->
                <svg v-else-if="flag.key === 'warehouse'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>
                <!-- Office icon -->
                <svg v-else-if="flag.key === 'office'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                <!-- Portaria icon -->
                <svg v-else-if="flag.key === 'portaria'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
                <!-- IA icon -->
                <svg v-else-if="flag.key === 'ia'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z"/>
                  <path d="M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z" opacity=".5"/>
                </svg>
                <div class="module-toggle">
                  <input type="checkbox" v-model="flag.enabled" :id="`flag-${flag.key}`" />
                  <span class="module-toggle-track"></span>
                </div>
              </div>
              <span class="module-card-label">{{ flag.label }}</span>
              <span class="module-card-status">{{ flag.enabled ? 'Ativo' : 'Desabilitado' }}</span>
            </label>
          </template>
        </div>
      </div>

      <!-- Recursos de IA (habilita/desabilita cada uso de IA individualmente) -->
      <div class="module-group module-group--ia" style="margin-top:24px;">
        <div class="module-group-title module-group-title--ia">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z"/><path d="M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z" opacity=".5"/></svg>
          Recursos de IA
        </div>
        <p class="ia-group-hint">
          O card "Modo IA" acima é o interruptor geral. Os recursos abaixo controlam cada uso de IA individualmente — um recurso só funciona se o Modo IA E o recurso estiverem ativos.
        </p>
        <div class="flags-list">
          <template v-for="flag in featureFlags" :key="flag.key">
            <label v-if="flag.group === 'ia'" class="flag-row flag-row--ia" :class="{ 'flag-row--dimmed': !iaModeEnabled }">
              <input type="checkbox" v-model="flag.enabled" />
              <span class="flag-label">{{ flag.label }}</span>
            </label>
          </template>
        </div>
        <p v-if="!iaModeEnabled" class="ia-group-warn">Modo IA desabilitado — nenhum recurso de IA funciona nesta obra, independente dos toggles acima.</p>
      </div>

      <!-- Features group -->
      <div class="module-group" style="margin-top:24px;">
        <div class="module-group-title">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          Funcionalidades
        </div>
        <div class="flags-list">
          <template v-for="flag in featureFlags" :key="flag.key">
            <label v-if="!['construction','maintenance','warehouse','office','ia'].includes(flag.key) && flag.group !== 'ia'" class="flag-row">
              <input type="checkbox" v-model="flag.enabled" />
              <span class="flag-label">{{ flag.label }}</span>
            </label>
          </template>
        </div>
      </div>
    </div>

    <p v-if="flagsError" class="data-error" style="margin-top:16px;">{{ flagsError }}</p>
    <p v-if="flagsSuccess" class="data-success" style="margin-top:16px;">{{ flagsSuccess }}</p>
    <button class="btn-admin-primary" style="margin-top:20px;" type="button" :disabled="flagsSaving" @click="saveFlags">
      {{ flagsSaving ? 'Salvando...' : 'Salvar módulos' }}
    </button>
  </div>
</template>

<script lang="ts">
import { computed, ref, inject, onMounted } from 'vue'
import { masterFetch } from '@/store/masterSession'

interface FeatureFlag {
  key: string
  label: string
  group?: string
  enabled: boolean
}

export default {
  name: 'AdminSysFlagsTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const featureFlags = ref<FeatureFlag[]>([])
    const flagsLoading = ref(false)
    const flagsSaving = ref(false)
    const flagsError = ref('')
    const flagsSuccess = ref('')

    const loadFlags = async () => {
      if (!detail?.value) return
      flagsLoading.value = true
      try {
        featureFlags.value = await masterFetch<FeatureFlag[]>(`/master/systems/${detail.value.systemId}/feature-flags`)
      } catch { /* ignore */ } finally {
        flagsLoading.value = false
      }
    }

    onMounted(loadFlags)

    const iaModeEnabled = computed(() => {
      const iaFlag = featureFlags.value.find((f: FeatureFlag) => f.key === 'ia')
      return iaFlag ? iaFlag.enabled : true
    })

    const saveFlags = async () => {
      flagsError.value = ''
      flagsSuccess.value = ''
      if (!detail?.value) return
      flagsSaving.value = true

      const flagSnapshot = featureFlags.value.map((f: FeatureFlag) => ({ key: f.key, label: f.label, enabled: f.enabled }))
      console.group(`[Feature Flags] ${detail.value.siteName} (${detail.value.systemId})`)
      flagSnapshot.forEach((f: FeatureFlag) => console.log(`  ${f.enabled ? '✅' : '❌'} ${f.key.padEnd(20)} ${f.label}`))
      console.groupEnd()

      try {
        await masterFetch(`/master/systems/${detail.value.systemId}/feature-flags`, {
          method: 'PUT',
          body: JSON.stringify({ flags: flagSnapshot.map((f: FeatureFlag) => ({ key: f.key, enabled: f.enabled })) })
        })
        flagsSuccess.value = 'Feature flags salvas.'
        console.log('[Feature Flags] Salvo com sucesso.')
      } catch (err: unknown) {
        flagsError.value = err instanceof Error ? err.message : 'Erro ao salvar.'
        console.error('[Feature Flags] Erro ao salvar:', err)
      } finally {
        flagsSaving.value = false
      }
    }

    return { featureFlags, flagsLoading, flagsSaving, flagsError, flagsSuccess, saveFlags, iaModeEnabled }
  }
}
</script>

<style lang="scss">
.flags-save-inline {
  margin-left: auto;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1.5px solid #0f4c81;
  background: #0f4c81;
  color: #fff;
  cursor: pointer;
  transition: background 0.12s;
  &:hover:not(:disabled) { background: #0a3a63; }
  &:disabled { opacity: 0.55; cursor: default; }
}

.flags-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;
}

.flag-row {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  background: #f9fafb;
  transition: border-color 0.15s;

  input[type='checkbox'] {
    accent-color: #0f4c81;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  &:hover { border-color: #0f4c81; }
}

.flag-label { font-size: 14px; color: #374151; }

/* ── Recursos de IA ── */
.module-group-title--ia { color: #7c3aed; svg { opacity: 1; } }
.ia-group-hint {
  margin: 0 0 4px; font-size: 12.5px; color: #6b7280; line-height: 1.5;
  background: rgba(124,58,237,.05); border-left: 3px solid #7c3aed;
  border-radius: 0 6px 6px 0; padding: 8px 12px; max-width: 560px;
}
.flag-row--ia {
  input[type='checkbox'] { accent-color: #7c3aed; }
  &:hover { border-color: #7c3aed; }
}
.flag-row--dimmed { opacity: .55; }
.ia-group-warn {
  margin: 4px 0 0; font-size: 12.5px; color: #b45309;
  background: rgba(217,119,6,.08); border: 1px solid rgba(217,119,6,.25);
  border-radius: 6px; padding: 7px 12px; max-width: 560px;
}

/* ── MODULE CARDS ── */
.module-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.module-group-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 2px;

  svg { opacity: 0.7; }
}

.module-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.module-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 14px 14px;
  border-radius: 12px;
  border: 1.5px solid #e5e7eb;
  background: #f9fafb;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  input[type='checkbox'] { display: none; }

  &:hover { border-color: #d1d5db; }

  &--on {
    background: #fff;
    box-shadow: 0 1px 6px rgba(0,0,0,.06);
  }

  &--construction.module-card--on {
    border-color: rgba(15,76,129,.35);
    background: rgba(15,76,129,.04);
    svg { color: #0f4c81; }
  }
  &--maintenance.module-card--on {
    border-color: rgba(217,119,6,.4);
    background: rgba(217,119,6,.04);
    svg { color: #d97706; }
  }
  &--warehouse.module-card--on {
    border-color: rgba(5,150,105,.4);
    background: rgba(5,150,105,.04);
    svg { color: #059669; }
  }
  &--office.module-card--on {
    border-color: rgba(234,88,12,.4);
    background: rgba(234,88,12,.04);
    svg { color: #ea580c; }
  }
  &--ia.module-card--on {
    border-color: rgba(124,58,237,.4);
    background: rgba(124,58,237,.04);
    svg { color: #7c3aed; fill: #7c3aed; }
  }
}

.module-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg { color: #9ca3af; transition: color 0.15s; }
}

.module-card-label {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
}

.module-card-status {
  font-size: 11px;
  color: #9ca3af;

  .module-card--on & { color: #6b7280; }
}

/* Toggle switch */
.module-toggle {
  position: relative;
  width: 34px;
  height: 20px;
  flex-shrink: 0;

  input { opacity: 0; position: absolute; inset: 0; margin: 0; cursor: pointer; z-index: 1; }
}

.module-toggle-track {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: #d1d5db;
  transition: background 0.18s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,.2);
    transition: transform 0.18s;
  }
}

.module-toggle input:checked + .module-toggle-track {
  background: #0f4c81;

  &::after { transform: translateX(14px); }
}

.module-card--maintenance .module-toggle input:checked + .module-toggle-track { background: #d97706; }
.module-card--warehouse .module-toggle input:checked + .module-toggle-track { background: #059669; }
.module-card--office .module-toggle input:checked + .module-toggle-track { background: #ea580c; }
.module-card--ia .module-toggle input:checked + .module-toggle-track {
  background: linear-gradient(90deg, #34d399, #fbbf24);
}
</style>
